import { Select, Input, DateInput } from 'components';
import moment from 'moment-timezone';
/*
 * If I can delete this file
 * No specific code for the client left
 */

export const ThalesSpecialConf = {
  orgId: 'b79191e5-6136-4145-b9b9-d1af6cec81d8',
  panelId: '8881dd85-3db4-4a59-b49e-7e1e3f9ccfd2',
  specialFields: [
    {
      name: '__thalesDeviceOS',
      accessor: (p: any) =>
        Array.isArray(p.__thalesDeviceOS)
          ? p.__thalesDeviceOS.join(', ')
          : p.__thalesDeviceOS,
      clientLabel: 'Config Smartphone',
      participantLabel: 'Smartphone Configuration',
      formComponent: (props: { name: string; label: string }) => (
        <Select isMulti options={['iOS', 'Android', 'Others']} {...props} />
      ),
    },

    {
      name: '__thalesWatchOS',
      accessor: (p: any) =>
        Array.isArray(p.__thalesDeviceOS)
          ? p.__thalesDeviceOS.join(', ')
          : p.__thalesDeviceOS,
      participantLabel: 'Smartwatch Configuration',
      clientLabel: 'Config Smartwatch',
      formComponent: (props: { name: string; label: string }) => (
        <Select
          isMulti
          options={['No smartwatch', 'Watch OS', 'Wear OS', 'Others']}
          {...props}
        />
      ),
    },
    {
      name: '__thalesContact',
      participantLabel: 'Would you like to be contacted ?',
      clientLabel: 'Contact',

      formComponent: (props: { name: string; label: string }) => (
        <Select options={['Yes', 'No']} {...props} />
      ),
    },
    {
      name: '__thalesPersona',
      participantLabel: 'Persona',
      clientLabel: 'Persona',

      formComponent: (props: { name: string; label: string }) => (
        <Select options={['Pilot', 'Cabin crew', 'Trainers']} {...props} />
      ),
    },
    {
      name: '__thalesMonitoring',
      participantLabel: 'Suivi',
      clientLabel: 'Suivi',
      formComponent: Input,
    },
    {
      name: '__thalesTouchpoint',
      participantLabel: 'Touchpoint',
      clientLabel: 'Touchpoint',
      formComponent: Input,
    },
    {
      name: '__thalesLastInteraction',
      participantLabel: 'Dernière interaction',
      clientLabel: 'Dernière interaction',
      formComponent: DateInput,
      accessor: (p: any) =>
        p.__thalesLastInteraction
          ? moment(p.__thalesLastInteraction).format('L')
          : null,
    },
  ],
};
